module.exports = __webpack_public_path__ + "img/hero-phone.640faed1.png";